import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Typography, Card, Button, Grid, LinearProgress, CardActionArea } from '@mui/material';
import { apiRequest } from '../functions/apiRequest';
import { toast } from 'react-toastify';

const token = localStorage.getItem('token');
const userID = parseInt(localStorage.getItem('userID'));

function MyPrograms() {
  const [programs, setPrograms] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchMyPrograms() {
      try {
        const data = await apiRequest('GET', false, `/dashboard-data/programs?user_id=${userID}`, token);
        setPrograms(data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching my programs:', error);
        toast.error('Failed to load programs.');
        setIsLoading(false);
      }
    }

    fetchMyPrograms();
  }, []);

  const handleCloseProgram = async (programId) => {
    if (window.confirm('Are you sure you want to close this program? All uncredited hours will be returned to the bank.')) {
      try {
        // Assuming an API endpoint to close a program and return uncredited hours
        const response = await apiRequest('PUT', JSON.stringify({ program_id: programId }), `/api/program/close/${programId}`, token);
        if (response.success) {
          toast.success('Program closed successfully!');
          // Refresh programs after closing one
          setPrograms(programs.filter(program => program.ProgramId !== programId));
        } else {
          toast.error('Failed to close program.');
        }
      } catch (error) {
        console.error('Error closing program:', error);
        toast.error('Error closing program.');
      }
    }
  };

  if (isLoading) {
    return <LinearProgress />;
  }

  return (
    <Grid
      container
      spacing={2}
      justifyContent="center"
      style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%)',
        minHeight: '100vh',
        fontFamily: 'Raleway',
        paddingTop: 40,
        paddingBottom: 40,
        paddingLeft: 50,
        paddingRight: 50,
      }}
    >
      <Grid item xs={12} md={12} lg={12} xl={8}>
        <Typography variant="h4" style={{ fontFamily: 'Raleway', marginBottom: 30, textAlign: 'center', fontWeight: 700, color: '#1976d2' }}>My Programs</Typography>
        <Grid container spacing={3} justifyContent="center">
          {programs.length > 0 ? (programs.map((program) => (
            <Grid item xs={12} sm={6} md={4} key={program.ProgramId}>
              <Card elevation={4} style={{ borderRadius: 15, padding: 25, height: 265, display: 'flex', flexDirection: 'column' }}>
                <CardActionArea onClick={() => window.location.href = `/program/${program.ProgramId}`} style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <div>
                    <Typography variant="h5" style={{ fontFamily: 'Raleway', fontWeight: 'bold', color: '#333' }}>{program.ProgramName}</Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      style={{
                        fontFamily: 'Raleway',
                        marginTop: 10,
                        height: 50,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      Description: {program.ProgramDescription || 'N/A'}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ fontFamily: 'Raleway' }}>
                      Start Date: {program.StartDate || 'N/A'}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ fontFamily: 'Raleway' }}>
                      Hours Requested: {program.HoursRequested || 'N/A'}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ fontFamily: 'Raleway' }}>
                      Hours Credited: {program.HoursCredited || 'N/A'}
                    </Typography>
                  </div>
                  {/* <div style={{ marginTop: 'auto' }}>
                    <Button
                      variant="contained"
                      style={{ backgroundColor: '#967bb6', color: 'white', borderRadius: 20, padding: '8px 20px', width: '100%' }}
                      onClick={(e) => { e.stopPropagation(); handleCloseProgram(program.ProgramId); }}
                    >
                      Close Program
                    </Button>
                  </div> */}
                </CardActionArea>
              </Card>
            </Grid>
          ))) : (
            <Grid item xs={12} style={{ textAlign: 'center', marginTop: 50 }}>
              <Typography variant="h6" style={{ fontFamily: 'Raleway', color: '#555' }}>No programs found. Start a new program today!</Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default MyPrograms; 